/**
 * Error with code wrapper exception.
 */
export default class ErrorWithCode extends Error {
  /**
   * Constructor function
   *
   * @param {object} error
   * @param {string} [error.message]
   * @param {string} [error.code] custom error code
   */
  constructor(error) {
    const {
      code,
      message
    } = error;

    // Pass remaining arguments (including vendor specific ones) to parent constructor
    super(message);
    this.name = 'ErrorWithCode';
    this.code = code;
    this.message = message;
  }
}